module.exports = __webpack_public_path__ + "static/img/logistics-h5-6.5426517.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logistics-h5-6.png
// module id = WbLr
// module chunks = 34